import axios, { AxiosRequestConfig } from 'axios';
import api, { decode } from '@/api';

import { storage } from '@/utils/storage';
import { ACCESS_TOKEN, REFRESH_TOKEN, REMEMBER_ME } from '@/constants/constant';

const requestRefreshToken = (config: AxiosRequestConfig) => {
  Object.assign(config, { retry: true });
  const rememberMe = storage.get(REMEMBER_ME);
  const refreshToken = storage.get(REFRESH_TOKEN, !rememberMe);
  return api
    .post('/auth/token', 'pauth.PbTokenRequest', { refreshToken })
    .then(({ data }) => {
      const { accessToken } = data;
      storage.set(ACCESS_TOKEN, accessToken, !rememberMe);
      return axios(config);
    })
    .catch((e) => {
      console.log(e);
      storage.remove(ACCESS_TOKEN, !rememberMe);
      storage.remove(REFRESH_TOKEN, !rememberMe);
    });
};

const axiosConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_SERVER,
  headers: {
    Accept: 'application/x-protobuf',
    'Content-Type': 'application/x-protobuf;',
    Pragma: 'no-cache',
  },
  // withCredentials: true,
  responseType: 'arraybuffer',
  transformRequest: (data) => {
    return data;
  },
  transformResponse: (data, headers) => {
    return decode(data, headers['x-protobuf-message']);
  },
};

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const p in axiosConfig) {
  (axios.defaults as any)[p] = (axiosConfig as any)[p];
}

axios.interceptors.request.use(
  (config) => {
    const remember = storage.get(REMEMBER_ME);
    const storageToken = storage.get(ACCESS_TOKEN, !remember);
    if (storageToken) {
      config.headers.Authorization = `Bearer ${storageToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log('api error', error, error.request, error.response);
    const orgRequest = error.config;
    if (error.response?.status === 401 && error.response?.data?.code === -40109 && !orgRequest.retry) {
      return requestRefreshToken(orgRequest);
    }
    return Promise.reject(error);
  },
);
